import React, { Component } from "react";
import _ from "lodash";
import { Scrubber } from 'react-scrubber';
import { formatTimestamp } from '../../utils/format';

class AudioScrubber extends Component {
  constructor(props) {
    super(props);

    this.state = {

    };
  }

  render() {
    const {
      current,
      maximum,
      updateCurrent,
    } = this.props;

    return (
    <div className="scrubber-container">
      <div className="scrubber-timestamp">
        {`${formatTimestamp(current)} / ${formatTimestamp(maximum)}`}
      </div>
      <Scrubber
        className="scrubber-scrubber"
        min={0}
        max={maximum}
        value={current}
        onScrubEnd={(value) => updateCurrent(value)}
        onScrubChange={(value) => updateCurrent(value)}
      />
    </div>
    );
  }

}

export default AudioScrubber;
